import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { del, post } from 'utils/http'

export const useCustomerAIContextActions = (customerId: any) => {
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const updateAIContext = async (aiContext: any) => post(`/management/customers/${customerId}/ai_context`, aiContext)

  const delAIContext = async () => del(`/management/customers/${customerId}/ai_context`)

  const upsertMutation = useMutation({
    mutationFn: updateAIContext,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', 'ai', customerId] })

      addNotification('AI Context upserted successfully', 'success')
    },
    onError: () => {
      addNotification('Error while upserting AI Context', 'error')
    },
  })

  const delMutation = useMutation({
    mutationFn: delAIContext,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', 'ai', customerId] })

      addNotification('AI Context deleted successfully', 'success')
    },
    onError: () => {
      addNotification('Error while deleting AI Context', 'error')
    },
  })

  return {
    upsert: upsertMutation.mutateAsync,
    del: delMutation.mutateAsync,
    isLoading: upsertMutation.isPending || delMutation.isPending,
  }
}
